import React, { useState, Suspense } from "react";
import "./App.css";
import { useEagerConnect, useInactiveListener } from "./hooks/useEagerConnect";
import { BrowserRouter, Route, Routes } from "react-router-dom";

// import {
// Home,
// Buy,
// BuyPropDetails,
// Rent,
// Explore,
// Sell,
// Profile,
// AllCollections,
// Admin,
// FinanceOption,
// SellPropDetails,
// RentPropDetails,
// BookedPropDetails,
// About,
// FaqComponent,
// Help,
// } from "./screens";
import { Footer, Header, ScrollToTop, Loader } from "./components";

const Home = React.lazy(() => import(`./screens/Home`));
const About = React.lazy(() => import(`./screens/About`));
const Buy = React.lazy(() => import(`./screens/Buy`));
const Help = React.lazy(() => import(`./screens/Help`));
const FaqComponent = React.lazy(() => import(`./screens/Faq`));
const BuyPropDetails = React.lazy(() => import(`./screens/BuyPropDetails`));
const Rent = React.lazy(() => import(`./screens/Rent`));
const Explore = React.lazy(() => import(`./screens/Explore`));
const Sell = React.lazy(() => import(`./screens/Sell`));
const Profile = React.lazy(() => import(`./screens/Profile`));
const AllCollections = React.lazy(() => import(`./screens/AllCollections`));
const Admin = React.lazy(() => import(`./screens/Admin`));
const FinanceOption = React.lazy(() => import(`./screens/FinanceOption`));
const SellPropDetails = React.lazy(() => import(`./screens/SellPropDetails`));
const RentPropDetails = React.lazy(() => import(`./screens/RentPropDetails`));
const BookedPropDetails = React.lazy(() =>
  import(`./screens/BookedPropDetails`)
);
const loader = <Loader />;
function App() {
  const [errorMessage, setErrorMessage] = useState();
  const [profileActiveTab, setProfileActiveTab] = useState(0);
  // const handleActiveTab = (tab) => {
  //   setProfileActiveTab(tab);
  // };
  console.log(profileActiveTab);
  useEagerConnect(setErrorMessage);
  useInactiveListener();

  return (
    <div className="App">
      {errorMessage ? <div style={{ color: "red" }}>{errorMessage}</div> : null}
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={loader}>
          <Header setErrorMessage={setErrorMessage} />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/buy" element={<Buy />} />
            <Route path="/rent" element={<Rent />} />
            <Route path="/sell" element={<Sell />} />
            <Route
              path="/Profile"
              element={<Profile activeTab={profileActiveTab} />}
            />
            <Route path="/explore" element={<Explore />} />
            <Route path="/buy-prop-details" element={<BuyPropDetails />} />
            <Route path="/sell-prop-details" element={<SellPropDetails />} />
            <Route path="/rent-prop-details" element={<RentPropDetails />} />
            <Route
              path="/booked-prop-details"
              element={<BookedPropDetails />}
            />
            <Route path="/all-collections" element={<AllCollections />} />
            <Route path="/admin" element={<Admin />} />
            <Route
              path="/buy-prop-details/select-payment"
              element={<FinanceOption />}
            />
            <Route
              path="/rent-prop-details/select-payment"
              element={<FinanceOption />}
            />
            <Route
              path="/select-payment"
              element={
                <FinanceOption
                  handleActiveTab={(tab) => setProfileActiveTab(tab)}
                />
              }
            />
            <Route path="/faq" element={<FaqComponent />} />
            <Route path="/help" element={<Help />} />
          </Routes>
          <Footer />
        </Suspense>
      </BrowserRouter>
    </div>
  );
}
// export default App;
export default function WrappedApp() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  );
}
